module.exports = __webpack_public_path__ + "media/images/bg/shapes/career/green-bf8edc99164a55520627c476ab426e8f.svg";